module.exports = __webpack_public_path__ + "img/cake.56f093c1.svg";